
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";

/**
 * JournalTemplateService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class JournalTemplateService<TJournalTemplate = unknown, TTemplateDistribution = unknown> {
    constructor(private readonly $apiService: ApiService) { }
    
    GetGLJournalTemplateDistributions(filterString?: string): Promise<TTemplateDistribution[]> {
        return this.$apiService.sendAuth("IJournalTemplateService/GetGLJournalTemplateDistributions", null, filterString);
    }
    GetGLJournalTemplates(filterString?: string): Promise<TJournalTemplate[]> {
        return this.$apiService.sendAuth("IJournalTemplateService/GetGLJournalTemplates", null, filterString);
    }
}
